import { formatNum } from '../../../tools/util'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

interface DashboardCardProps {
  title: string
  mainNumber: string | number
  icon: string
  link?: string
  items: Array<{
    label: string
    value: string | number
    link?: string
    color?: string
  }>
}

export default function DashboardCard({
  title,
  mainNumber,
  icon,
  link,
  items,
}: DashboardCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardInfo}>
          <div className={styles.title}>{title}</div>
          <div className={styles.mainNumber}>
            <Link to={link || '/'} className={styles.mainNumberLink}>
              {formatNum(mainNumber, 999999)}
            </Link>
          </div>
        </div>
        <div className={styles.iconWrapper}>
          <img src={icon} alt={title} className={styles.icon} />
        </div>
      </div>
      <div className={styles.cardContent}>
        {/* 每行两个状态；行顺序为 [2,3]、[0,1]、[4,5]，与历史布局一致并支持第 5、6 项 */}
        {[
          [2, 3],
          [0, 1],
          [4, 5],
        ].map((indices, rowIndex) => (
          <div key={rowIndex} className={styles.itemRow}>
            {indices.map((dataIndex, colIndex) => {
              const item = items[dataIndex]

              return (
                <span key={colIndex}>
                  {item ? (
                    <Link
                      to={item.link || '/'}
                      className={styles.mainNumberLink}
                    >
                      {item.label}:{' '}
                      <span style={{ color: item.color }}>
                        {formatNum(item.value, 999999)}
                      </span>
                    </Link>
                  ) : (
                    <span className={styles.placeholderText}>&nbsp;</span>
                  )}
                </span>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}
import { formatNum } from '../../../tools/util'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'

interface DashboardCardProps {
  title: string
  mainNumber: string | number
  icon: string
  link?: string
  items: Array<{
    label: string
    value: string | number
    link?: string
    color?: string
  }>
}

export default function DashboardCard({
  title,
  mainNumber,
  icon,
  link,
  items,
}: DashboardCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardInfo}>
          <div className={styles.title}>{title}</div>
          <div className={styles.mainNumber}>
            <Link to={link || '/'} className={styles.mainNumberLink}>
              {formatNum(mainNumber, 999999)}
            </Link>
          </div>
        </div>
        <div className={styles.iconWrapper}>
          <img src={icon} alt={title} className={styles.icon} />
        </div>
      </div>
      <div className={styles.cardContent}>
        {/* 每行两个状态；行顺序为 [2,3]、[0,1]、[4,5]，与历史布局一致并支持第 5、6 项 */}
        {[
          [2, 3],
          [0, 1],
          [4, 5],
        ].map((indices, rowIndex) => (
          <div key={rowIndex} className={styles.itemRow}>
            {indices.map((dataIndex, colIndex) => {
              const item = items[dataIndex]

              return (
                <span key={colIndex}>
                  {item ? (
                    <Link
                      to={item.link || '/'}
                      className={styles.mainNumberLink}
                    >
                      {item.label}:{' '}
                      <span style={{ color: item.color }}>
                        {formatNum(item.value, 999999)}
                      </span>
                    </Link>
                  ) : (
                    <span className={styles.placeholderText}>&nbsp;</span>
                  )}
                </span>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}
